import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'sbw-checkbox-demo',
    templateUrl: './checkbox-demo.component.html'
})
export class CheckboxDemoComponent implements OnInit {
    public checkboxes = [{ id: 'checkbox1', checked: true }, { id: 'checkbox2', checked: false }, { id: 'checkbox3', checked: true }];
    public checkboxChanged(checked, checkbox) {
        if (checkbox) {
            checkbox.checked = checked;
            console.log('selectChanged', this.checkboxes);
            return;
        }

        console.log('checkboxChanged', checked);
    }
    constructor() { }

    ngOnInit() {
    }

}
